module.exports = __webpack_public_path__ + "static/chunks/src/page-thanks/part-footer/assets/footer-bg.164fffab452026245d103628c98d0ea5.webp";